import type { CustomEmojiShape } from "./types";
import { sortShapesByGroupAndColor } from "./utils";

const constructCustomEmojiShape = (
  name: string,
  src: string,
): CustomEmojiShape => ({
  id: `shape-${name}`,
  name,
  short_names: [name],
  skins: [
    {
      src,
    },
  ],
});

const SHAPE_TYPES = [
  { id: "circle", name: "Circle" },
  { id: "square", name: "Square" },
  { id: "diamond", name: "Diamond" },
  { id: "triangle", name: "Triangle" },
  { id: "star", name: "Star" },
  { id: "heart", name: "Heart" },
] as const;

const shapeAssets = import.meta.glob<string>(
  "/app/assets/images/emoji-picker-v3/shapes/*/*.png",
  { eager: true, import: "default" },
);

const getAssetDirectory = (path: string): string | undefined =>
  path.split("/").at(-2);

const getAssetName = (path: string): string => {
  const filename = path.split("/").at(-1) ?? "";
  return filename.replace(/^shape-/, "").replace(/\.png$/, "");
};

const getShapes = (shapeType: string): CustomEmojiShape[] =>
  Object.entries(shapeAssets)
    .filter(([path]) => getAssetDirectory(path) === shapeType)
    .map(([path, src]) => constructCustomEmojiShape(getAssetName(path), src));

export const CUSTOM_SHAPE_DATA_SET = SHAPE_TYPES.map(({ id, name }) => ({
  id,
  name,
  emojis: sortShapesByGroupAndColor(getShapes(id)),
}));

export const customEmojiShapeUrl = (identifier: string): string | undefined => {
  const shapeTypeData = CUSTOM_SHAPE_DATA_SET.find(
    shapeType => shapeType.id === identifier.split("-")[1],
  );
  const emoji = shapeTypeData?.emojis?.find(emoji => emoji.id === identifier);

  return emoji?.skins?.[0]?.src;
};
